<section class="no-padding">
    <ngb-carousel *ngIf="isMobile"
        [showNavigationArrows]="true" 
        [showNavigationIndicators]="false"
        interval="12000"
        [keyboard]="true"
        [pauseOnHover]="true"
        [wrap]="true"
        [activeId]="'firstSlide'"
        >
        <ng-template ngbSlide id="slide_{{i}}"  *ngFor="let slide of listaSlide; let i = index;">
            <div class="picsum-img-wrapper ">
                <img src="{{slide.img}}" alt="Angular Carousel 1">
              </div>
              <div class="carousel-caption ">
                <h3></h3>
                <p></p>
              </div>
        </ng-template>
        <!-- <ng-template ngbSlide id="secondSlide">
          <div class="picsum-img-wrapper">
            <img src="./assets/img-slide/slider-02.jpg" alt="Angular Carousel 2">
          </div>
          <div class="carousel-caption">
            <h3></h3>
                <p></p>
          </div>
        </ng-template>
        <ng-template ngbSlide id="slide3">
            <div class="picsum-img-wrapper">
              <img src="./assets/img-slide/slider-03.jpg" alt="Angular Carousel 2">
            </div>
            <div class="carousel-caption">
              <h3></h3>
                  <p></p>
            </div>
          </ng-template> -->
      </ngb-carousel>

      <ngb-carousel *ngIf="!isMobile"
        [showNavigationArrows]="true" 
        [showNavigationIndicators]="false"
        interval="12000"
        [keyboard]="true"
        [pauseOnHover]="true"
        [wrap]="true"
        [activeId]="'firstSlide'"
        >
          
            
            <ng-template ngbSlide id="firstSlide">
      
                       
                <div class="picsum-img-wrapper noMobile" *ngFor="let slide of listaSlide">
                    <img src="{{slide.img}}" alt="Angular Carousel 1">
                  </div>

            </ng-template>  
          
          <!-- <div class="carousel-caption noMobile1">
            <h3></h3>
            <p></p>
          </div>
          <div class="picsum-img-wrapper noMobile">
            <img src="./assets/img-slide/slider-02.jpg" alt="Angular Carousel 2">
          </div>
          <div class="carousel-caption noMobile2">
            <h3></h3>
            <p></p>
          </div>
          <div class="picsum-img-wrapper noMobile">
            <img src="./assets/img-slide/slider-03.jpg" alt="Angular Carousel 1">
          </div>
          <div class="carousel-caption noMobile3">
            <h3></h3>
            <p></p>
          </div> -->
        

        
        
      </ngb-carousel>
      <!-- <carousel [height]="400"
      [cellsToShow]="3" [objectFit]="'cover'"
      [cellWidth]="'100%'"
      [dots]="false"
      [loop]="true"
      [cellsToScroll]="1" class="grid-articles">
          
          
              <article class="carousel-cell post-entry" >
                  <a  class="post-image"><img alt="" src="./assets/img-slide/slider-01.jpg"></a>
                  <div class="post-entry-overlay">
                      <div class="post-entry-meta">
                          <div class="product-description">
                              <div class="product-category"></div>
                              <div class="product-title">
                                  <h3></h3>
                              </div>
                              <div class="product-price"><ins></ins>
                              </div>
                             
                          </div>
  
                      </div>
                  </div>
              </article>
          
              <article class="carousel-cell post-entry" >
                  <a  class="post-image"><img alt="" src="./assets/img-slide/slider-02.jpg"></a>
                  <div class="post-entry-overlay">
                      <div class="post-entry-meta">
                          <div class="product-description">
                              <div class="product-category"></div>
                              <div class="product-title">
                                  <h3></h3>
                              </div>
                              <div class="product-price"><ins></ins>
                              </div>
                              
                          </div>
  
                      </div>
                  </div>
              </article>
            
          
              <article class="carousel-cell post-entry" >
                  <a class="post-image"><img alt="" src="./assets/img-slide/slider-03.jpg"></a>
                  <div class="post-entry-overlay">
                      <div class="post-entry-meta">
                          <div class="product-description">
                              <div class="product-category"></div>
                              <div class="product-title">
                                  <h3></h3>
                              </div>
                              <div class="product-price"><ins></ins>
                              </div>
                             
                          </div>
  
                      </div>
                  </div>
              </article>
  
              
          
          
        </carousel> -->
    
    
    
</section>


<div class="call-to-action py-5  mb-0 call-to-action-dark" *ngIf="!loggato">
    <div class="container">
        <div class="row" >
            <div class="col-lg-10">
                <h3>
                Benvenuto su {{nomeAzienda}}.
                </h3>
                <p>
                Richiedi un account per visualizzare i prezzi ed acquistare presso il nostro Store  Online.
                </p>
            </div>
        <div class="col-lg-2">
            <a class="btn btn-block" routerLink="/registrati">Registrati</a>
            <a class="btn btn-block btn-secondary" routerLink="/accedi">Accedi</a>
        </div>
    </div>
    </div>
</div>
<section > 
    <div class="container">
        <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6 col-6 text-center boxLinee" *ngFor="let linea of listLinee" (click)="openGruppo(linea)">
                <img [src]="linea.img" class="boxHome" style="width: 80%;">
                <h3 style="padding-top: 10px;padding-bottom: 25px; font-weight: 700;">{{linea.titolo}}</h3>
            </div>
        </div>
    </div>
</section>
<!-- <p class="avviso"><a class="avviso" href="./assets/download/Ingromarket_catalogo_Natale_2022.pdf" target="_blank">Scopri il nostro catalogo con le confezioni natalizie</a></p> -->
<app-prodotti [arrProdotti]="listaProdotti" [titolo]="titoloProd" [page]="page" [numCol]="3" *ngIf="listaProdotti"></app-prodotti>

<!-- <app-punti-forza></app-punti-forza> -->

<!-- SHOP WIDGET PRODUTCS -->
<section > 
    <div class="container">
        
        <div class="row">
            <!-- <div class="col-lg-4" *ngIf="listaProdottiPromo">
                <div class="heading-text heading-line">
                    <h4 class="bold">In promozione</h4>
                </div>

                <div class="widget-shop prod-evid">
                    <app-prodotti-lista [arrProdotti]="listaProdottiPromo" ></app-prodotti-lista>
                    
                    
                </div>
            </div> -->
            <!-- <div class="col-lg" *ngIf="listaProdottiEvidenza">
                <div class="heading-text heading-line">
                    <h4 class="bold">In evidenza</h4>
                </div>

                <div class="widget-shop prod-evid">
                    <app-prodotti-lista [arrProdotti]="listaProdottiEvidenza"></app-prodotti-lista>

                </div>
            </div> -->
            <!-- <div class="col-lg-4" *ngIf="listaProdottiVenduti">
                <div class="heading-text heading-line">
                    <h4 class="bold">Più venduti</h4>
                </div>

                <div class="widget-shop prod-evid">
                    <app-prodotti-lista [arrProdotti]="listaProdottiVenduti"></app-prodotti-lista>

                </div>
            </div> -->
        </div>
    </div>
</section>
<!-- end: SHOP WIDGET PRODUTCS -->

